// components/SimulationList.tsx
import React, { useEffect, useState } from "react";
import {
  Button, Table, TableHead, TableRow, TableCell,
  TableBody, Dialog, DialogTitle, DialogContent,
  TableContainer,
  Paper,
  TablePagination,
  Stack,
  Box,
  TextField,
  InputAdornment,
  DialogActions,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Menu,
  Grid,
  Autocomplete,
  Tab,
  Tabs,
  TableFooter,
  Popper,
  
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import SearchIcon from '@mui/icons-material/Search';
// import { Simulation } from "../models/Simulation";
import { IClient, IParametreBDC, ISimulationBDC2 } from "../../../dataTypes/GlobalDataType";
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import CalculateIcon from '@mui/icons-material/Calculate';
// import {
//   getSimulations,
//   deleteSimulation
// } from "../services/simulationService";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { deleteSimulation } from "./SimulationBDC2";

import SimulationBDC2Form from "./SimulationBDC2Form";
import { useAuthHeader, useAuthUser } from "../../../Services/Auth/sessionAuth";
import Utilisateur from "../../../Models/Utilisateur";
import { fetchDataTable2, formatDate, GlobalExportToCSV, GlobalExportToJSON, GlobalExportToPDF, GlobalExportToWord } from "../../../utilitaires/globalFunction";

import formatNumber from "../../../Functions/Traitement/FormatNumber";

import jsPDF from "jspdf";
//import "jspdf-autotable"
import autoTable from "jspdf-autotable"; // ✅ important
import { GlobalExportToExcel } from "../../../utilitaires/globalFunction";
import { Controller, useForm } from "react-hook-form";

import ListIcon from '@mui/icons-material/List';
import InfoIcon from '@mui/icons-material/Info';
import RefreshIcon from "@mui/icons-material/Refresh";

//import { IconButton } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import GetAppIcon from '@mui/icons-material/GetApp';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import ArticleIcon from '@mui/icons-material/Article';
import DescriptionIcon from '@mui/icons-material/Description';
import SaveIcon from '@mui/icons-material/Save';
import UpdateIcon from '@mui/icons-material/Update';
//import SweetAlert from "../../../Functions/Traitement/SweetAlert";
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";   
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import SearchModalMUI2 from "../../SearchModalMUI2";
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearchModalMUI3 from "../../SearchModalMUI3";
import { Filter } from "@mui/icons-material";

const SimulationBDC2List: React.FC = () => {
     const auth = useAuthUser()
     
      const authHeader = useAuthHeader()
  
 const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))

  const [clients, setClients] = useState<IClient[]>([]);
  const [paramBDC, setParamBDC] = useState<IParametreBDC[]>([]);
  const [data, setData] = useState<ISimulationBDC2[]>([]);
  const [open, setOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [selected, setSelected] = useState<ISimulationBDC2 | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0); // Page actuelle
  const [rowsPerPage, setRowsPerPage] = useState(5); // Tu peux ajuster le nombre par défaut ici
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorElInt, setAnchorElInt] = useState<null | HTMLElement>(null);
  const [activ, setActiv] = useState(true); // Page actuelle
  const [tab, setTab] = useState(0); 
  const [openDialog, setOpenDialog] = useState(false);
  const open1 = Boolean(anchorEl);
  const MySwal = withReactContent(Swal);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  //const [formData, setFormData] = useState<Partial<IClient>>({});

    const [formDataCli, setFormDataCli] = useState({
           NUMCLI: "",
           lib_NUMCLI: "",
           // autres champs...
          });;
    //const [resultat, setResultat] = useState<any>(null);
  
  // const [echeancier, setEcheancier] = useState<
  //   { periode: number; dateImput: string;  interet: number; taxe: number; netAPayer: number }[]
  // >([]);

  let searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI",  Choix: 22 }
  
  const [echeancier, setEcheancier] = useState<{
    periode: number;
    dateImput: string;
    interet: number;
    taxe: number;
    netAPayer: number;
  }[]>([]);
  
   const [resultat, setResultat] = useState({
    montInt: 0,
    montTaxe: 0,
    montNet: 0,
   // echeancier: [],
  });  
  
  const totalInteret = echeancier.reduce((acc, row) => acc + row.interet, 0);
const totalTaxe = echeancier.reduce((acc, row) => acc + row.taxe, 0);
const totalNet = echeancier.reduce((acc, row) => acc + row.netAPayer, 0);

  const { register, handleSubmit, reset,setValue, control,watch } = useForm<ISimulationBDC2>({
   defaultValues: {
   IDSIMUL: 0,
  CODSIMUL: "",
  NUMCLI: "",
  NOMCLI: "",
  TYPBDC: "",
  TYPIMPUTINT: "",
  lib_TYPBDC: "",
  FREQPROV: "",
  lib_FREQPROV: "",
  DUREE: 0,
  MONTANT: 0,

  TXINT: 0,
  MTNINT: 0,
  MTNNETAPAYER: 0,
  TXTAXE: 0,
  MTNTAXE: 0,
  MTNPROVFREQ: 0,
  MTNTAXEFREQ: 0,

  DATDEBUT: null as unknown as Date,  // ou new Date() si tu veux la date du jour
  DATFIN: null as unknown as Date,
  CODAGE: "",
  DATCRE: new Date(),                 // date de création par défaut
  UTISAI: "",
  OPTION: "",
  CDETAT: "",
   },
 });

const viderFormulaire = () => {
  reset({
    IDSIMUL: 0,
  CODSIMUL: "",
  NUMCLI: "",
  NOMCLI: "",
  TYPBDC: "",
  TYPIMPUTINT: "",
  lib_TYPBDC: "",
  FREQPROV: "",
  lib_FREQPROV: "",
  DUREE: 0,
  MONTANT: 0,

  TXINT: 0,
  MTNINT: 0,
  MTNNETAPAYER: 0,
  TXTAXE: 0,
  MTNTAXE: 0,
  MTNPROVFREQ: 0,
  MTNTAXEFREQ: 0,

  DATDEBUT: Perss.datjour as unknown as Date,  // ou new Date() si tu veux la date du jour
  DATFIN: Perss.datjour as unknown as Date,
  CODAGE: Perss.codage,
  DATCRE:  new Date(Perss.datjour),                 // date de création par défaut
  UTISAI: Perss.coduti,
  OPTION: "",
  CDETAT: "",
  });
};

// 📄 Filtrage des données en fonction du terme de recherche
  const filteredDataBranch = data.filter((item) =>
    Object.values(item).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );
  // 📄 Pagination après filtrage
  const paginatedDataBranch = filteredDataBranch.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

   // Charger la liste
    const fetchData = async (int:string) => {
        try {
                 // console.log(apiEndpoints.bureaux)
                 if (int=="")
                 {
                  var params = { CodeAgence: Perss.codage , Table: "SIMULATIONBDC", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }
         
                 }else {
                  alert(searchTerm)
                     var params = { CodeAgence: "" , Table: "SIMULATIONBDC", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "", Init: searchTerm, choix: 37, colfiltre: "CODAGE", valfiltre: Perss.codage }
      
                 }
            
                  const res = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
                   const data: ISimulationBDC2[] = res//res.data?.Result?.Table || [];
                  //console.log(res)
                 if (res.length!==0)
                     {       
                       setData(data);
                       console.log("✅ Simulations chargées :", data);
                
                     }else{ console.warn("Aucune donnée reçue !");}
                  }catch (err) {
                  console.error("Erreur de chargement:", err);
                 // setError("Impossible de charger les données .");
                 } finally {
                  //setLoading2(false);
                  return []
                 }
          
        //   const res = await axios.get(API_URL);
        //   return res.data;
    //  const res = await axios.get(api);
     // setData(res.data);
    };

    // Charger la liste
    const fetchDataTypeBDC = async (int:string) => {
        try {
                 // console.log(apiEndpoints.bureaux)
                 if (int=="")
                 {
                  var params = { CodeAgence: Perss.codage , Table: "PARAMBDC", Colonne1: "CODBDC", Colonne2: "LIBELL", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }
         
                 }else {
                  alert(searchTerm)
                     var params = { CodeAgence: "" , Table: "PARAMBDC", Colonne1: "CODBDC", Colonne2: "LIBELL", Colagence: "", Init: searchTerm, choix: 37, colfiltre: "CODAGE", valfiltre: Perss.codage }
      
                 }
            
                  const res = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
                   const data: IParametreBDC[] = res//res.data?.Result?.Table || [];
                   
                  //console.log(res)
                 if (res.length!==0)
                     {       
                       setParamBDC(data);
                       console.log("✅ Simulations chargées :", data);
                
                     }else{ console.warn("Aucune donnée reçue !");}
                  }catch (err) {
                  console.error("Erreur de chargement:", err);
                 // setError("Impossible de charger les données .");
                 } finally {
                  //setLoading2(false);
                  return []
                 }
          
        //   const res = await axios.get(API_URL);
        //   return res.data;
    //  const res = await axios.get(api);
     // setData(res.data);
    };
    
  // 🔁 Gestion du changement de page
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // 🔁 Gestion du changement de nombre de lignes
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Revenir à la première page après changement
  };

  const handleSearchClick = () => {
    // Appel API avec le terme de recherche
    //onSearch(searchTerm);
  };
 function calculer(row: ISimulationBDC2) {
      setSelected(row);
      const prochaineDate = new Date(row.DATDEBUT  || Perss.datjour);
      
    
      const freq = (row.FREQPROV || "").toUpperCase();
      const montant = Number(row.MONTANT) || 0;
      const tauxInteret = Number(row.TXINT) || 0;
      const tauxTaxe = Number(row.TXTAXE) || 0;
      const duree = Number(row.DUREE) || 0; 
    
      // if (!freq || !montant || !tauxInteret || !duree || !prochaineDate) {
      //   Swal.fire({
      //     icon: "warning",
      //     title: "Champs manquants",
      //     text: "Veuillez renseigner la fréquence, le montant, le taux et la durée.",
      //     target: document.body, // ✅ Rend le popup au-dessus du Dialog
      //     backdrop: true,
      //   });
      //   return;
      // }
    
      // 🔹 2. Déterminer la durée en jours selon la fréquence
      let jours = 0;
      switch (freq) {
        case "A": jours = 360; break;   // Annuel
        case "S": jours = 180; break;   // Semestriel
        case "T": jours = 90; break;    // Trimestriel
        case "M": jours = 30; break;    // Mensuel
        case "B": jours = 15; break;    // Bimensuel
        case "F": jours = 60; break;    // Bimestriel
        case "H": jours = 7; break;     // Hebdomadaire
        case "J": jours = 1; break;     // Journalier
        default: jours = 30;            // Valeur par défaut
      }
    
      
        prochaineDate.setDate(prochaineDate.getDate() + jours * duree);
      
      
      //   //form.setFieldValue("DATFIN", prochaineDate.toISOString().split("T")[0]);
      //  // alert(form.getFieldValue("DATFIN"))
      // // 🔹 3. Calculs financiers
      // const montInt = Math.round((montant * tauxInteret * duree * jours) / 36000) ; // intérêt brut
      // const montTaxe = Math.round((montInt * tauxTaxe) / 100) ;                      // taxe totale
      // const montNet = Math.round(montInt - montTaxe) ;                               // net à percevoir
      // const montTaxeFreq = Math.round( montTaxe / duree);                            // taxe par période
      // const montProvFreq = Math.round(montInt / duree) ;                             // provision par période
     // 1️⃣ Calcul brut de l'intérêt
let montIntBrut = (montant * tauxInteret * duree * jours) / 36000;

// 2️⃣ Calcul provisoire de l'intérêt par période (avant recalage)
let montProvFreq = Math.round(montIntBrut / duree);

// 3️⃣ Recalage de l'intérêt total
let montInt = montProvFreq * duree;

// 4️⃣ Calcul brut de la taxe (avant arrondis)
let montTaxeBrut = (montInt * tauxTaxe) / 100;

// 5️⃣ Calcul provisoire de la taxe périodique
let montTaxeFreq = Math.round(montTaxeBrut / duree);

// 6️⃣ Recalage de la taxe totale
let montTaxe = montTaxeFreq * duree;

// 7️⃣ Net perçu
let montNet = montInt - montTaxe;

      // 🔹 4. Calcul de la date de fin
      const dateFin = new Date(prochaineDate);
      dateFin.setDate(prochaineDate.getDate() + jours * duree);
    
      // 🔹 5. Génération du tableau d’échéances
      //const echeancier = [];
      //let dateEcheance = new Date(prochaineDate);
      let dateEcheance = new Date(row.DATDEBUT|| Perss.datjour);
     // const echeancier: any[] = []; // 🔥 reset obligatoire à chaque calcul
      const newEcheancier = [];
      for (let i = 1; i <= duree; i++) {
        const prochaine = new Date(dateEcheance);
        prochaine.setDate(prochaine.getDate() + jours);
    
        newEcheancier.push({
          periode: i,
          dateImput: dateEcheance.toLocaleDateString(),
          //dateFin: prochaine.toLocaleDateString(),
          interet: montProvFreq,
          taxe: montTaxeFreq,
          netAPayer: montProvFreq - montTaxeFreq,
        });
    
        dateEcheance = prochaine;
      }
     
      

  setResultat({
  montInt,
  montTaxe,
  montNet,
 // newEcheancier,
});
setEcheancier(newEcheancier);
setOpenDialog(true);
      // setCal(true)
    }
  function simuler() {
    const prochaineDate = new Date(watch("DATDEBUT")  || Perss.datjour);
   
    // 🔹 1. Récupération fiable des valeurs depuis formData
    const freq = (watch("FREQPROV") || "").toUpperCase();
    const montant = Number(watch("MONTANT")) || 0;
    const tauxInteret = Number(watch("TXINT")) || 0;
    const tauxTaxe = Number(watch("TXTAXE")) || 0;
    const duree = Number(watch("DUREE")) || 0; 
  
    if (!freq || !montant || !tauxInteret || !duree || !prochaineDate) {
      Swal.fire({
        icon: "warning",
        title: "Champs manquants",
        text: "Veuillez renseigner la fréquence, le montant, le taux et la durée.",
        target: document.body, // ✅ Rend le popup au-dessus du Dialog
        backdrop: true,
      });
      return;
    }
  
    // 🔹 2. Déterminer la durée en jours selon la fréquence
    let jours = 0;
    switch (freq) {
      case "A": jours = 360; break;   // Annuel
      case "S": jours = 180; break;   // Semestriel
      case "T": jours = 90; break;    // Trimestriel
      case "M": jours = 30; break;    // Mensuel
      case "B": jours = 15; break;    // Bimensuel
      case "F": jours = 60; break;    // Bimestriel
      case "H": jours = 7; break;     // Hebdomadaire
      case "J": jours = 1; break;     // Journalier
      default: jours = 30;            // Valeur par défaut
    }
  
   
      prochaineDate.setDate(prochaineDate.getDate() + jours * duree);
        const formattedDate =  prochaineDate.toISOString().split("T")[0]
//    // alert( prochaineDate.toISOString().split("T")[0].substring(0, 10))
    
//       //form.setFieldValue("DATFIN", prochaineDate.toISOString().split("T")[0]);
//      // alert(form.getFieldValue("DATFIN"))
//     // 🔹 3. Calculs financiers

//     // 1️⃣ Calcul brut de l'intérêt
// let montIntBrut = (montant * tauxInteret * duree * jours) / 36000;

// // 2️⃣ Calcul provisoire de l'intérêt par période
// let montProvFreq = Math.round(montIntBrut / duree);

// // 3️⃣ Recalage de l'intérêt total pour être cohérent
// let montInt = montProvFreq * duree;

//    // const montInt = Math.round(((montant * tauxInteret * duree * jours) / 36000)) || 0 // intérêt brut
//                        // taxe totale
//     const montTaxe = Math.round(montInt * tauxTaxe / 100) || 0 ;                      // taxe totale
//     const montNet = Math.round(montInt - montTaxe) || 0;                               // net à percevoir
//     const montTaxeFreq = Math.round(montTaxe / duree) || 0 ;                            // taxe par période
//     //const montProvFreq = Math.round(montInt / duree) || 0;                             // provision par période
//     // 🔹 4. Mise à jour des états locaux

// 1️⃣ Calcul brut de l'intérêt
let montIntBrut = (montant * tauxInteret * duree * jours) / 36000;

// 2️⃣ Calcul provisoire de l'intérêt par période (avant recalage)
let montProvFreq = Math.round(montIntBrut / duree);

// 3️⃣ Recalage de l'intérêt total
let montInt = montProvFreq * duree;

// 4️⃣ Calcul brut de la taxe (avant arrondis)
let montTaxeBrut = (montInt * tauxTaxe) / 100;

// 5️⃣ Calcul provisoire de la taxe périodique
let montTaxeFreq = Math.round(montTaxeBrut / duree);

// 6️⃣ Recalage de la taxe totale
let montTaxe = montTaxeFreq * duree;

// 7️⃣ Net perçu
let montNet = montInt - montTaxe;

    setValue("MTNINT", montInt || 0, { shouldDirty: true });
    setValue("MTNTAXE", montTaxe || 0, { shouldDirty: true });
    setValue("MTNTAXEFREQ", montTaxeFreq || 0, { shouldDirty: true });
    setValue("MTNNETAPAYER", montNet || 0, { shouldDirty: true });
    setValue("MTNPROVFREQ", montProvFreq || 0, { shouldDirty: true });
    setValue("DATFIN", (formattedDate as unknown as Date)   , { shouldDirty: true });
    
  
   
  }

   function NextDate() {
    const prochaineDate = new Date(watch("DATDEBUT")  || Perss.datjour);
   // e.preventDefault();
  //alert(formData.MONTANT)
    // 🔹 1. Récupération fiable des valeurs depuis formData
    const freq = (watch("FREQPROV") || "").toUpperCase();
    const duree = Number(watch("DUREE")) || 0; 
  
   
    // 🔹 2. Déterminer la durée en jours selon la fréquence
    let jours = 0;
    switch (freq) {
      case "A": jours = 360; break;   // Annuel
      case "S": jours = 180; break;   // Semestriel
      case "T": jours = 90; break;    // Trimestriel
      case "M": jours = 30; break;    // Mensuel
      case "B": jours = 15; break;    // Bimensuel
      case "F": jours = 60; break;    // Bimestriel
      case "H": jours = 7; break;     // Hebdomadaire
      case "J": jours = 1; break;     // Journalier
      default: jours = 30;            // Valeur par défaut
    }
  
   
      prochaineDate.setDate(prochaineDate.getDate() + jours * duree);
        const formattedDate =  prochaineDate.toISOString().split("T")[0]
   
    setValue("DATFIN", (formattedDate as unknown as Date)   , { shouldDirty: true });
    
  
   
  }
    
    
  const getClients = async (int:string) => {
   
       try {
           // console.log(apiEndpoints.bureaux)
           if (int=="")
           {
            var params = { CodeAgence: Perss.codage , Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }
   
           }else {
           // alert(searchTerm)
               var params = { CodeAgence: "" , Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "", Init: searchText, choix: 37, colfiltre: "CODAGE", valfiltre: Perss.codage }

           }
      
            const res = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
             const data: ISimulationBDC2[] = res//res.data?.Result?.Table || [];
            //console.log(res)
           if (res.length!==0)
               {       
                 setClients(data);
                 console.log("✅ clients chargées :", data);
          
               }else{ console.warn("Aucune donnée reçue !");}
            }catch (err) {
            console.error("Erreur de chargement:", err);
           // setError("Impossible de charger les données .");
           } finally {
            //setLoading2(false);
            return []
           }
    
  //   const res = await axios.get(API_URL);
  //   return res.data;
  };

   const getSimulations = async (int:string) => {
   
       try {
           // console.log(apiEndpoints.bureaux)
           if (int=="")
           {
            var params = { CodeAgence: Perss.codage , Table: "SIMULATIONBDC", Colonne1: "CODBDC", Colonne2: "LIBELL", Colagence: "CODAGE", Init: "", choix: 32, colfiltre: "", valfiltre: "" }
   
           }else {
            alert(searchTerm)
               var params = { CodeAgence: "" , Table: "SIMULATIONBDC", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: "", Init: searchTerm, choix: 37, colfiltre: "CODAGE", valfiltre: Perss.codage }

           }
      
            const res = await fetchDataTable2(Data.ApiUrl.AnySearch, params, authHeader());
             const data: ISimulationBDC2[] = res//res.data?.Result?.Table || [];
            //console.log(res)
           if (res.length!==0)
               {       
                 setClients(data);
                 console.log("✅ clients chargées :", data);
          
               }else{ console.warn("Aucune donnée reçue !");}
            }catch (err) {
            console.error("Erreur de chargement:", err);
           // setError("Impossible de charger les données .");
           } finally {
            //setLoading2(false);
            return []
           }
    
  //   const res = await axios.get(API_URL);
  //   return res.data;
  };

   // 🔹 Ouvre le menu
  const handleClickExport = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
   // 🔹 Ouvre le menu
      const handleClickExportInt = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorElInt(event.currentTarget);
      };

const handleCloseExportInt = () => {
    setAnchorElInt(null);
  };
   // 🔹 Fonctions d’exportation (à implémenter selon ton besoin)
  const handleExport = (format: any) => {
    handleCloseExport();
    switch (format) {
      case 'excel':
       // console.log('Export Excel', data);
        GlobalExportToExcel(paginatedDataBranch,"Exportation simulation BDC","SimulationBDC")
        // Appeler ici ta fonction d’export Excel
        break;
      case 'pdf':
        //console.log('Export PDF', data);
        // Appeler ici ta fonction d’export PDF
        GlobalExportToPDF(paginatedDataBranch,"Exportation simulation BDC","SimulationBDC")
        break;
      case 'csv':
       // console.log('Export CSV', data);
        // Appeler ici ta fonction d’export CSV
       GlobalExportToCSV(paginatedDataBranch,"Exportation simulation BDC","SimulationBDC") 
        break;
      case 'json':
       // console.log('Export JSON', data);
        // Appeler ici ta fonction d’export JSON
        GlobalExportToJSON(paginatedDataBranch,"Exportation simulation BDC","SimulationBDC") 
        break;
      default:
        break;
    }
  };
 const handleExportInt = (format: any) => {
      handleCloseExportInt();
      switch (format) {
        case 'excel':
         // console.log('Export Excel', data);
          GlobalExportToExcel(echeancier,"Exportation tableau imputaion interets "+selected?.IDSIMUL+"-"+selected?.NOMCLI,"TableauInteretsBDC")
          // Appeler ici ta fonction d’export Excel
          break;
        case 'pdf':
          //console.log('Export PDF', data);
          // Appeler ici ta fonction d’export PDF
          GlobalExportToPDF(echeancier,"Exportation tableau imputaion interets "+selected?.IDSIMUL+"-"+selected?.NOMCLI,"TableauInteretsBDC")
          break;
           case 'word':
          //console.log('Export PDF', data);
          // Appeler ici ta fonction d’export PDF
          GlobalExportToWord(echeancier,"Exportation tableau imputaion interets "+selected?.IDSIMUL+"-"+selected?.NOMCLI,"TableauInteretsBDC")
          break;
        case 'csv':
         // console.log('Export CSV', data);
          // Appeler ici ta fonction d’export CSV
         GlobalExportToCSV(echeancier,"Exportation tableau imputaion interets "+selected?.IDSIMUL+"-"+selected?.NOMCLI,"TableauInteretsBDC") 
          break;
        case 'json':
         // console.log('Export JSON', data);
          // Appeler ici ta fonction d’export JSON
          GlobalExportToJSON(echeancier,"Exportation tableau imputaion interets "+selected?.IDSIMUL+"-"+selected?.NOMCLI,"TableauInteretsBDC") 
          break;
        default:
          break;
      }
    };
  // 🔹 Ferme le menu
  const handleCloseExport = () => {
    setAnchorEl(null);
  };
  
  const handleNew = () => {
    //reset();
    viderFormulaire();
    setSelected(null);
    setTab(1);
    setActiv(true)
    //setCompte([])
  };
const handleEdit = (row: any) => {
    //viderFormulaire();
    //alert(row.DATDEBUT) 
     const cleanRow = {
    ...row,
    DATDEBUT: row.DATDEBUT ? new Date(row.DATDEBUT).toISOString().substring(0,10) : "",
    DATFIN: row.DATFIN ? new Date(row.DATFIN).toISOString().substring(0,10) : "",
   
  };

  setSelected(cleanRow);
  reset(cleanRow);
    // setSelected(row);
    // reset(row);
    setTab(1);
    setActiv(true)
    //getComptes(row.NUMCLI)
    
  };

  const handleDelete = async (id: number) => {
    // if (window.confirm("Confirmer la suppression ?")) {
    //   await axios.delete(`${api}/${id}`);
    //   fetchData("");
    // }
  };

   
  const loadData = async () => {
    const data = await getSimulations("");

    setClients(data);
  };

  useEffect(() => {
    fetchDataTypeBDC("")
   // loadData();
   //getSimulations("")
    setActiv(false)
  }, []);
  const onSubmit = async (values: any) => {

    
      if (!formDataCli.NUMCLI || !formDataCli.lib_NUMCLI ) {
        Swal.fire({
          icon: "warning",
          title: "Champs manquants",
          text: "Veuillez renseigner l'indice client, le nom du client.",
          target: document.body, // ✅ Rend le popup au-dessus du Dialog
          backdrop: true,
        });
        return;
      }

      if (values.MONTANT==0 ) {
        Swal.fire({
          icon: "warning",
          title: "Champs manquants",
          text: "Veuillez renseigner le montant.",
          target: document.body, // ✅ Rend le popup au-dessus du Dialog
          backdrop: true,
        });
        return;
      }

      

        values.NUMCLI= formDataCli.NUMCLI  
        values.NOMCLI= formDataCli.lib_NUMCLI
        values.CODAGE=Perss.codage
         values.UTISAI=Perss.coduti
        //NOMCLI= formData.NOMCLI   
       // alert( values.NUMCLI)
       // alert( values.NOMCLI)
      // if (selected) {
      //   await axios.put(`${api}/${selected.IDBDC}`, values);
      // } else {
      //   await axios.post(api, values);
      // }
  //alert(selected)
  
        if (!selected ) {
        //  alert("Add")
          //  console.log("hellp"+simulation)
          //  alert(formData)
         //     console.log(values)
            // 🔹 Étape 1 : Afficher la boîte SweetAlert
          const result = await MySwal.fire({
            title: selected ? "Modification simulation bon de caisse abc" : "Création simulation bon de caisse abc",
            text: `Voulez-vous ${selected ? "modifier" : "créer"} le bon de caisse : ${values.CODSIMUL} ?`,
            showCancelButton: true,
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
            icon: "question",
            confirmButtonColor: "green",
            cancelButtonColor: "darkred",
            customClass: {
              popup: "swal-front",
            },
             target: document.body, // ✅ garantit que le popup est dans le body
          });
      
                          if (result.isConfirmed) {
                              //alert("OUI")
                              //setLoading(true);
                             // setIsSubmit(true)
                            //  alert("papa")
                            // alert(values.CDETAT)
                           
                             //console.log(values.CDETAT)
                              console.log(values);
                              let data = Crypter.encrypt(JSON.stringify(values));
                               console.log(data)
                              let config = {
                                  method: 'post',
                                  maxBodyLength: Infinity,
                                  url: Data.ApiUrl.CreateSimulationBDC,
                                  headers: {
                                      'CypherParamBDC': data,
                                      'Authorization': authHeader(),
                                      'Content-Type': 'application/json'
                                  }
                              };
                              axios.request(config)
                                  .then((response) => {
                                     // setLoading(false);
                                      if (response.data) {
                                          const res = JSON.parse(Crypter.decrypt(response.data));
                                          let code = res.Result
                                          //console.log(Demand)
          
                                          if (res.StatutCode == 200) {
          
                                              if (code == 'Existe') {
                                                //  SweetAlert.fire({ title: res.Message, text: "Ce code existe déja svp choisissez un autre", icon: "warning" })
                                              // 🔹 Étape 3 : Notifier succès
               MySwal.fire({
                icon: "success",
                title: "Succès",
                text: `Simulation ${selected ? "modifiée" : "créée"} avec succès !`,
                confirmButtonColor: "green",
                customClass: { popup: "swal-front" },
              });
      
              // Fermer le dialog parent et recharger les données
            //  onSaved();
                                              } else {
          
                                                  //form.resetFields()
                                                  //setIsSubmit(false)
                                                 // HandleAnnul()
                                                //  SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                              // 🔹 Étape 3 : Notifier succès
               MySwal.fire({
                icon: "success",
                title: "Succès",
                text: `Simulation ${selected ? "modifiée" : "créée"} avec succès !`,
                confirmButtonColor: "green",
                customClass: { popup: "swal-front" },
              });
      
              // Fermer le dialog parent et recharger les données
             // onSaved();
                                              }
          
                                          }
                                          else {
                                            // 🔹 Étape 3 : Notifier succès
               MySwal.fire({
                icon: "warning",
                title: "Warning",
                text: `Simulation ${selected ? "modifiée" : "créée"} erreur !`,
                confirmButtonColor: "green",
                customClass: { popup: "swal-front" },
              });
      
              // Fermer le dialog parent et recharger les données
            //  onSaved();
                                              //SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                          }
                                      }
                                  })
                                  .catch((error) => {
                                     // setLoading(false);
                                      console.log(error)
                                      // 🔹 Étape 3 : Notifier succès
               MySwal.fire({
                icon: "error",
                title: "Error Front",
                text: `Simulation ${selected ? "modifiée" : "créée"} error !`,
                confirmButtonColor: "green",
                customClass: { popup: "swal-front" },
              });
      
              // Fermer le dialog parent et recharger les données
             // onSaved();
                                      //SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                                  });
                          }
                      // } )
                  }
                  // ********************************************************************************************************************************
                 else {
      //alert(selected.CDETAT)
      
                  if (selected.CDETAT!='01')
                    {
                       Swal.fire({
            icon: "warning",
            title: "Modification simulation",
            text: "Impossible de mofifier cette simulation: il a déjà fait l'objet d'une validation",
            target: document.body, // ✅ Rend le popup au-dessus du Dialog
            backdrop: true,
          });
          return;
                    }
                  values.CODSIMUL=values.CODSIMUL
                 //  formData.lib_TYPBDC=simulation.CODSIMUL
                  //formData.CODSIMUL
      
                   console.log(values)
                      // SweetAlert.fire({
                      //     title: "Mise à jour type bon de caisse",
                      //     text: "Voulez-vous Mettre à jour le bon de caisse' : " + form.getFieldValue("LIBELL"),
                      //     showCancelButton: true,
                      //     color: "green",
                      //     confirmButtonText: "Yes",
                      //     confirmButtonColor: "green",
                      //     cancelButtonColor: "darkred",
                      //     cancelButtonText: "No",
                      //     showLoaderOnConfirm: true,
                      //     icon: "question"
                      // }).then((res) => {
          const result = await MySwal.fire({
            title: selected ? "Modification simulation bon de caisse" : "Création simulation bon de caisse",
            text: `Voulez-vous ${selected ? "modifier" : "créer"} le bon de caisse : ${values.CODSIMUL} ?`,
            showCancelButton: true,
            confirmButtonText: "Oui",
            cancelButtonText: "Non",
            icon: "question",
            confirmButtonColor: "green",
            cancelButtonColor: "darkred",
            customClass: {
              popup: "swal-front",
            },
             target: document.body, // ✅ garantit que le popup est dans le body
          });
                          if (result.isConfirmed) {
                              //setLoading(true);
                              //setIsSubmit(true)
          
                              let data = Crypter.encrypt(JSON.stringify(values));
                              let config = {
                                  method: 'put',
                                  maxBodyLength: Infinity,
                                  url: Data.ApiUrl.UpdateSimulationBDC,
                                  headers: {
                                      'CypherParamBDC': data,
                                      'Authorization': authHeader(),
                                      'Content-Type': 'application/json'
                                  },
                                  data: data
                              };
          
                              axios.request(config)
                                  .then((response) => {
                                     // setLoading(false);
                                      if (response.data) {
                                          const res = JSON.parse(Crypter.decrypt(response.data));
                                          //console.log(res)
                                          if (res.StatutCode == 200) {
                                              let code = res.Result
          
                                              if (code == 'INCONNU') {
                                                  SweetAlert.fire({ title: res.Message, text: "Ce code n'existe pas", icon: "warning" })
                                              } else {
          
                                                  //form.resetFields()
                                                  //setIsSubmit(false)
                                               //   HandleAnnul()
                                                  SweetAlert.fire({ title: res.Message, text: "Code : " + code, icon: "success" })
                                              }
                                              // setIsSubmit(false)
                                              // HandleAnnul()
                                              // SweetAlert.fire({ title: "Mise à jour Effectuer avec Success", text: "Code : " + res.Message, icon: "success" })
          
                                          }
                                          else {
                                              SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                          }
                                      }
                                  })
                                  .catch((error) => {
                                   //   setLoading(false);
                                      console.log(error)
                                      SweetAlert.fire({ title: "Error Front", text: error, icon: "error" })
                                  });
                          }
                      // })
      
                  }
  
  
      fetchData("");
      // reset();
      viderFormulaire();
      setSelected(null);
      setTab(0);
      setActiv(true)
      //setCompte([])
    };

  // const handleDelete = async (id: number) => {
  //   await deleteSimulation(id);
  //   loadData();
  // };

  return (
    <Box mt={3} ml={2} mr={2}  fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  sx={{p:1, height: 'auto',overflowY: 'visible',}} >
        <Box mb={3}>
          {/* <h3>Liste des simulations bon de caisse</h3> */}
           <legend style={{ fontSize: '1.5rem' }} > Simulations bon de caisse</legend>
        </Box>

         <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            sx={{
              borderBottom: "1px solid black",
              mb: 2,
              "& .MuiTab-root": {
                border: "1px solid white",
                borderRadius: "5px 5px 0 0",
                marginRight: 1,
                backgroundColor: "transparent",
                color: "black", // <-- inactif = noir
                fontWeight: "bold",
                textTransform: "none",
                transition: "all 0.3s ease",
                minHeight: 35,
                "&:hover": {
                  color: "blue",
                  cursor: "pointer",
                },
                "&.Mui-selected": {
                  color: "white",     // <-- actif = blanc
                  backgroundColor: "#008040",
                },
              },
            }}
          >
      <Tab label="Liste simulation" icon={<ListIcon />} iconPosition="start" />
      <Tab
        label={selected ? "Détail simulation " : "Détail simulation"}
        icon={<Filter />}
        iconPosition="start"
      />
        </Tabs>


      {tab === 0 && (
        <Box   sx={{ p:1,  borderRadius: 3, background:'white'}}>
             <Box  mb={3} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {/* Groupe de boutons à gauche */}
            <Box sx={{ display: "flex", gap: "10px" }}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleNew}
                 sx={{ borderRadius: 2, fontWeight: 'bold' }}
              >
                Ajouter
              </Button>
             
              <Button
                variant="contained"
                color="primary"
                startIcon={<VisibilityIcon />}
                onClick={() => fetchData(searchTerm)}
                 sx={{ borderRadius: 2, fontWeight: 'bold' }}
              >
                Consulter
              </Button>

               <Button
                variant="contained"
                color="primary"
                startIcon={<RefreshIcon />}
                onClick={() => fetchData("")}
                 sx={{  borderRadius: 2, fontWeight: 'bold' }}
              >
                Actualiser
              </Button>
            </Box>
          
            {/* Bouton Exporter à droite */}
            <Button
              variant="contained"
              color="success"
              startIcon={<GetAppIcon />}
              onClick={handleClickExport}
              
              sx={{ borderRadius: 2, fontWeight: 'bold' }}
            >
              Exporter
            </Button>
          
            {/* Menu pour les formats d'exportation */}
            <Menu
              anchorEl={anchorEl}
              // open={open1}
               open={Boolean(anchorEl)}    // ouvert si anchorEl != null
              onClose={handleCloseExport}
               anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
          
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  mt: 1,
                  minWidth: 180,
                },
              }}
               
            >
              <MenuItem onClick={() => handleExport('excel')}>
                <ListItemIcon><TableChartIcon color="primary" /></ListItemIcon>
                <ListItemText>Excel (.xlsx)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExport('pdf')}>
                <ListItemIcon><PictureAsPdfIcon color="error" /></ListItemIcon>
                <ListItemText>PDF (.pdf)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExport('word')}>
               <DescriptionIcon sx={{ color: "#2B579A" }} /> {/* Bleu Word */}
                <ListItemText>Word (.docx)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExport('csv')}>
                <ListItemIcon><ArticleIcon color="info" /></ListItemIcon>
                <ListItemText>CSV (.csv)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExport('json')}>
                <ListItemIcon><DescriptionIcon color="secondary" /></ListItemIcon>
                <ListItemText>JSON (.json)</ListItemText>
              </MenuItem>
            </Menu>
          </Box>
             
           
            {/* Zone de recherche */}
                                                       
               <Box sx={{ mb: 2 }}>
                <TextField
                  label="Recherche"
                  variant="outlined"
                  fullWidth
                  size="small"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputLabelProps={{
                    sx: {
                      fontWeight: 'bold',
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {/* Icône cliquable */}
                        <IconButton onClick={(e) =>getSimulations(searchTerm)} edge="end">
                          <SearchIcon color="primary" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
          {/* <Button
            variant="contained"
            color="primary"
            onClick={handleNew}
            sx={{ mb: 2 }}
          >
            Nouveau BDC
          </Button> */}
          <TableContainer component={Paper}
          elevation={3} sx={{
                        // --- Styles pour les ascenseurs ---
                        maxHeight: 'auto', // Hauteur maximale pour l'ascenseur vertical (ajustez selon besoin)
                        overflowY: 'auto', // Active l'ascenseur vertical si le contenu dépasse
                        overflowX: 'auto', // Active l'ascenseur horizontal si le contenu dépasse
                        width: '100%', // S'assure que le conteneur prend toute la largeur disponible
                        minWidth: '900', // Optionnel: Si vous voulez une largeur minimale pour le conteneur
                      }}>
            <Table>
              <TableHead>
                <TableRow sx={{  height: 32, minHeight: 32, size:"small",  }}>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}}>Code </TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold"}}>Indice client</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold"}}>Nom client</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor:" #107C41", fontWeight:"bold"}}>Type BDC</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Fréquence</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Durée</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Montant</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Taux interêt</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Montant interet</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Taux taxe</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Monatnt taxe</TableCell>
                {/* <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Date début</TableCell>
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Date fin</TableCell> */}
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Crée le</TableCell>
                  <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Crée par</TableCell>
                  {/* <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Status</TableCell> */}
                <TableCell sx={{ color: '#fff', py: 1,backgroundColor: " #107C41", fontWeight:"bold"}}>Actions</TableCell>
              </TableRow>
              </TableHead>
              <TableBody>
                   {paginatedDataBranch.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={10} align="center">Aucune entrée de code trouvée.</TableCell>
                      </TableRow>
                    ) : (
                      paginatedDataBranch.map((item,index) => (
                        <TableRow   key={`${item.IDSIMUL}-${item.NUMCLI}-${item.CODAGE}`}  sx={{
                          cursor: 'pointer',
                          backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
                          '&:hover': {
                          // backgroundColor: '#e0f7fa', // Couleur au survol
                          // background: `linear-gradient(90deg, #1c3adc 0%, #365eff 100%)`,
                          //color: '#fff', // Texte blanc sur fond sombre
                          background: 'linear-gradient(90deg, #eaf3ff 0%, #dceeff 100%)',
                            },
                                  }} > 
                          {/* Clé unique pour React */}
                          <TableCell sx={{ py: 0 }}>{item.IDSIMUL}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.NUMCLI}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.NOMCLI}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.TYPBDC}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.FREQPROV}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{(item.DUREE)}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{formatNumber(Number(item.MONTANT))}</TableCell>
                          <TableCell sx={{ py: 0 ,textAlign: 'right'}}>{ (item.TXINT)}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{formatNumber(Number(item.MTNINT))}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{(item.TXTAXE)}</TableCell>
                          <TableCell sx={{ py: 0,textAlign: 'right' }}>{formatNumber(Number(item.MTNTAXE))}</TableCell>
                          {/* <TableCell sx={{ py: 0 }}> {item.DATDEBUT ? new Date(item.DATDEBUT).toLocaleDateString() : 'N/A'}</TableCell>
                          <TableCell sx={{ py: 0 }}> {item.DATFIN ? new Date(item.DATFIN).toLocaleDateString() : 'N/A'}</TableCell> */}
                          <TableCell sx={{ py: 0 }}> {item.DATCRE ? new Date(item.DATCRE).toLocaleDateString() : 'N/A'}</TableCell>
                          <TableCell sx={{ py: 0 }}>{item.UTISAI ?? 'N/A'}</TableCell>
                          {/* <TableCell sx={{ py: 0 }}>{item.CDETAT ?? 'N/A'}</TableCell> */}
                          
                          <TableCell sx={{ py: 0 }}>
                            
                            <IconButton color="success" onClick={() =>calculer(item)}>
                              <ListIcon />
                            </IconButton>
                            <IconButton color="primary" onClick={() => { handleEdit(item); }}>
                              <EditIcon />
                            </IconButton>
                            <IconButton color="error" onClick={() =>handleDelete(item.IDSIMUL)}>
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
              
              </TableBody>
            </Table>

          </TableContainer>

          {/* Pagination */}
          <TablePagination
                component="div"
                count={filteredDataBranch.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
                labelRowsPerPage="Lignes par page"
            />
        </Box>
      )}

      {tab === 1 && (
        <Box  mb={2} fontStyle="inherit" className='border'
          component="form"
          onSubmit={handleSubmit(onSubmit)}
          sx={{p:1,borderRadius: 3, background:'white'}}
         
        //   sx={{ display: "grid", gap: 2}}
        >
             
               <Grid container spacing={2} mb={1}>

                  <Grid item xs={6}>   
                  <SearchModalMUI3   control={control} width={250} Titre="Recherche client" label="Indice client"  name="NUMCLI"  value={formDataCli.NUMCLI} disabledCode={!activ} disabledLibell={true} libelleValue={formDataCli.lib_NUMCLI}  onChange={(name, value) => setFormDataCli((prev) => ({ ...prev, [name]: value }))}  Parametre={searchClient}/> 
                 </Grid>
             </Grid>
              <Grid container spacing={2} mb={2} >
                
                  
                    <Grid item xs={3}>
                    <Controller
                          
                                name="TYPBDC"
                                disabled={!activ}
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { onChange, value } }) => (
                              <Autocomplete
                                    fullWidth
                                    options={paramBDC}
                                    disabled={!activ}
                                      // --- Texte affiché dans le menu ---
                                    getOptionLabel={(option) =>
                                      option ? `[${option.CODBDC}] - [${option.LIBELL}]` : ""
                                    }
                                    // --- Recherche automatique MUI ---
                                    filterOptions={(options, state) =>
                                      options.filter(
                                        (o) =>
                                          o.CODBDC.toLowerCase().includes(state.inputValue.toLowerCase()) ||
                                          o.LIBELL.toLowerCase().includes(state.inputValue.toLowerCase())
                                      )
                                    }
                                    value={paramBDC.find(s => s.CODBDC === value) || null}
                                    onChange={(e, selected) => {
                                      if (selected) {
                                        
                                        onChange(selected.CODBDC);
                                        setValue("FREQPROV", selected.FREQPROV, { shouldDirty: true });
                                        setValue("DUREE", selected.DUREE, { shouldDirty: true });
                                        setValue("TYPIMPUTINT", selected.TYPIMPUTINT, { shouldDirty: true });
                                        
                                      } else {
                                        onChange("");
                                      // setCompte([])
                                      }
                                    }}
                                    PopperComponent={(props) => <Popper {...props} disablePortal />}
                                    // PopperComponent={(props) => (
                                    //          <Popper {...props} style={{ zIndex: 1500 }} />
                                    //        )}
                                    renderInput={(params) => (
                                      <TextField  {...params} 
                                      label="Type BDC"   size="small" required 
                                      disabled={!activ}
                                      sx={{
                                            borderRadius: 10,
                                            "& .MuiInputLabel-root": {
                                              fontWeight: "bold",
                                              fontSize: "16px",
                                            },
                                            "& .MuiOutlinedInput-root legend": {
                                              maxWidth: 0,
                                            }
                                          }}

                                          // onChange={(e) => e.target.value.toUpperCase()}
                                      />
                                    )}
                                  />
                                )}
                              />
                                {/* <TextField label="Code simulation" fullWidth {...register("CODSIMUL")} required /> */}
                    </Grid>
                  
                    <Grid item xs={1.5}>
                          <TextField 
                          label="Type imputation" size="small" 
                           disabled={true}
                          fullWidth {...register("TYPIMPUTINT")} required  
                          //InputLabelProps={{ shrink: true }}
                          sx={{
                              borderRadius: 10,
                              "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                              },
                              "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                              }
                            }}
                             InputLabelProps={{ shrink: watch("TYPIMPUTINT") ? true : false }}  
                          />
                    </Grid>
                    <Grid item xs={1.5}>
                        <TextField 
                        label="Fréquence" size="small" 
                        disabled={true}
                        fullWidth {...register("FREQPROV")}  required 
                          sx={{
                              borderRadius: 10,
                              "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                              },
                              "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                              }
                            }}
                            InputLabelProps={{ shrink: watch("FREQPROV") ? true : false }}
                        //InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={1.5}>
                        <TextField 
                        label="Durée" size="small" 
                         disabled={!activ}
                        fullWidth {...register("DUREE")}  required 
                        //InputLabelProps={{ shrink: true }}
                          sx={{
                              borderRadius: 10,
                              "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                              },
                              "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                              }
                            }}
                            //  InputLabelProps={{ shrink: watch("DUREE") ? true : false }}
                              onBlur={() => NextDate()}
                        />
                    </Grid>
              </Grid>

                <Grid container spacing={2} mb={2}>
                     
                     <Grid item xs={1.5}>
                            <TextField label="Montant" size="small" type="number" 
                             disabled={!activ}
                            fullWidth {...register("MONTANT")} required 
                            // InputLabelProps={{ shrink: true }} 
                              InputProps={{
                            inputProps: {
                            style: { textAlign: "right" }
                                }
                                }}

                                  sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                          //  InputLabelProps={{ shrink: watch("MONTANT") ? true : false }} 
                            />
                      </Grid>
                      
                      <Grid item xs={1.5}>
                            <TextField label="Taux Intérêt" size="small" type="number" 
                             disabled={!activ}
                            fullWidth {...register("TXINT")}  required 
                            //InputLabelProps={{ shrink: true }} 
                              InputProps={{
                             inputProps: { step: "0.001", min: 0 },
                            style: { textAlign: "right" }
                              
                                }}
                                  sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                             //   InputLabelProps={{ shrink: watch("TXINT") ? true : false }} 
                            />
                      </Grid>
                      <Grid item xs={1.5}>
                            <TextField label="Taux taxe" size="small" type="number" 
                             disabled={!activ}
                            fullWidth {...register("TXTAXE")}  required 
                            // InputLabelProps={{ shrink: true }} 
                            InputProps={{
                            inputProps: { step: "0.001", min: 0 },
                            style: { textAlign: "right" }
                            
                               
                                }}
                                  sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                            //   InputLabelProps={{ shrink: watch("TXTAXE") ? true : false }} 
                            />
                      </Grid>
                      <Grid item xs={1.5}>
                            <TextField label="Date debut" size="small" type="date" 
                             disabled={!activ}
                            fullWidth {...register("DATDEBUT")}  required 
                            //InputLabelProps={{ shrink: true }}
                              sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                                InputLabelProps={{ shrink: watch("DATDEBUT") ? true : false }}
                                 onBlur={() => NextDate()}
                            />
                      </Grid>
                      <Grid item xs={1.5}>
                            <TextField label="Date fin" size="small" type="date" 
                              disabled={true}
                            fullWidth {...register("DATFIN")}  required 
                            // InputLabelProps={{ shrink: true }}
                            sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                              InputLabelProps={{ shrink: watch("DATFIN") ? true : false }}
                            />
                      </Grid>

                      
                   
                </Grid>
               

                <Grid container spacing={2} mb={2}>
                  
                      <Grid item xs={1.5}>
                            <TextField label="Montant Intérêt" size="small" type="number" 
                             disabled={true}
                            fullWidth {...register("MTNINT")}  
                            //InputLabelProps={{ shrink: true }} 
                              InputProps={{
                            inputProps: {
                            style: { textAlign: "right" }
                                }
                                }}
                                  sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                                InputLabelProps={{ shrink: watch("MTNINT") ? true : false }} 
                            />
                      </Grid>

                      
                      <Grid item xs={1.5}>
                            <TextField label="Montant taxe" size="small" type="number" 
                             disabled={true}
                            fullWidth {...register("MTNTAXE")}  
                            //InputLabelProps={{ shrink: true }}
                              InputProps={{
                            inputProps: {
                            style: { textAlign: "right" }
                                }
                                }}
                                  sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}
                                 InputLabelProps={{ shrink: watch("MTNTAXE") ? true : false }} 
                            />
                      </Grid>
                      <Grid item xs={1.5}>
                            <TextField label="Montant à payer" size="small" type="number" 
                             disabled={true}
                            fullWidth {...register("MTNNETAPAYER")}  
                            //InputLabelProps={{ shrink: true }} 
                            InputProps={{
                            inputProps: {
                            style: { textAlign: "right" }
                                }
                                }}
                                  sx={{
                                borderRadius: 10,
                                "& .MuiInputLabel-root": {
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                },
                                "& .MuiOutlinedInput-root legend": {
                                  maxWidth: 0,
                                }
                              }}

                                InputLabelProps={{ shrink: watch("MTNNETAPAYER") ? true : false }} 
                            />
                      </Grid>
                      <Grid item xs={1.5}>
                          <TextField label="Montant provision" size="small" type="number" 
                           disabled={true}
                          fullWidth {...register("MTNPROVFREQ")}  
                          //InputLabelProps={{ shrink: true }} 
                          InputProps={{
                          inputProps: {
                          style: { textAlign: "right" }
                              }
                              }}
                                sx={{
                              borderRadius: 10,
                              "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                              },
                              "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                              }
                            }}
                                  InputLabelProps={{ shrink: watch("MTNPROVFREQ") ? true : false }} 
                          />
                    </Grid>
                    <Grid item xs={1.5}>
                          <TextField label="Taxe/Provison" size="small" type="number" 
                           disabled={true}
                          fullWidth {...register("MTNTAXEFREQ")}  
                          //InputLabelProps={{ shrink: true }} 
                          InputProps={{
                          inputProps: {
                          style: { textAlign: "right" }
                              }
                              }}
                                sx={{
                              borderRadius: 10,
                              "& .MuiInputLabel-root": {
                                fontWeight: "bold",
                                fontSize: "16px",
                              },
                              "& .MuiOutlinedInput-root legend": {
                                maxWidth: 0,
                              }
                            }}
                                InputLabelProps={{ shrink: watch("MTNTAXEFREQ") ? true : false }} 
                          />
                    </Grid>
                </Grid>
              
          
          <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
             <Button  variant="contained"  color="primary"  onClick={() => { simuler()} }
             startIcon={<CalculateIcon /> } 
                sx={{ borderRadius: 2, fontWeight: 'bold' }}>
             Simuler
              
            </Button>
            <Button  disabled={!activ} variant="contained"  color="primary"  type="submit" 
            
             
             startIcon={selected ? <UpdateIcon /> : <SaveIcon />} 
             sx={{ borderRadius: 2, fontWeight: 'bold' }}>
              {selected? "Mettre à jour" : "Enregistrer"}
               
            </Button>
           

            <Button variant="contained"  color="primary" onClick={() => { setTab(0); viderFormulaire();setActiv(false)} }
             startIcon={<CancelIcon />}
              sx={{ borderRadius: 2, fontWeight: 'bold' }}>
              Annuler
            </Button>
          </Box>
        </Box>
      )}
      
  
 <Dialog
  open={openDialog}
  onClose={() => setOpenDialog(false)}
  maxWidth="lg"
  fullWidth
>
  <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" ,backgroundColor: "#107C41",
    color: "white", }}
  >Tableau imputation des interets {selected?.NUMCLI+"-"+selected?.NOMCLI}
   <IconButton onClick={() => setOpenDialog(false)} size="small">
    <CloseIcon />
  </IconButton>
  </DialogTitle>

  <DialogContent sx={{ minHeight: 300 }}>

    {/* Résumé */}
    {echeancier && (
      <Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 2,
    mb: 2,
    px: 1,
  }}
>
  {/* 🔹 Infos sur une ligne */}
  <Box sx={{ display: "flex", gap: 3 }}>
    <p>
      <b>Intérêt brut :</b>{" "}
      {Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2 }).format(resultat.montInt)}
    </p>

    <p>
      <b>Taxe :</b>{" "}
      {Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2 }).format(resultat.montTaxe)}
    </p>

    <p>
      <b>Net à percevoir :</b>{" "}
      {Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2 }).format(resultat.montNet)}
    </p>
  </Box>

  {/* 🔹 Bouton exportation */}
  <Button
    variant="contained"
    color="success"
    startIcon={<GetAppIcon />}
    onClick={handleClickExportInt}
    sx={{ borderRadius: 2, fontWeight: "bold" }}
  >
    Exporter
  </Button>
   {/* Menu pour les formats d'exportation */}
            <Menu
              anchorEl={anchorElInt}
              // open={open1}
               open={Boolean(anchorElInt)}    // ouvert si anchorEl != null
              onClose={handleCloseExportInt}
               anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
          
              PaperProps={{
                sx: {
                  borderRadius: 3,
                  mt: 1,
                  minWidth: 180,
                },
              }}
               
            >
              <MenuItem onClick={() => handleExportInt('excel')}>
                <ListItemIcon><TableChartIcon color="primary" /></ListItemIcon>
                <ListItemText>Excel (.xlsx)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExportInt('pdf')}>
                <ListItemIcon><PictureAsPdfIcon color="error" /></ListItemIcon>
                <ListItemText>PDF (.pdf)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExportInt('word')}>
               <DescriptionIcon sx={{ color: "#2B579A" }} /> {/* Bleu Word */}
                <ListItemText>Word (.docx)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExportInt('csv')}>
                <ListItemIcon><ArticleIcon color="info" /></ListItemIcon>
                <ListItemText>CSV (.csv)</ListItemText>
              </MenuItem>
              <MenuItem onClick={() => handleExportInt('json')}>
                <ListItemIcon><DescriptionIcon color="secondary" /></ListItemIcon>
                <ListItemText>JSON (.json)</ListItemText>
              </MenuItem>
            </Menu>
</Box>

      // <Box sx={{ p: 2, mb: 3, background: "#f7f7f7", borderRadius: 2 }}>
      //   <p><b>Intérêt brut :</b> { resultat.montInt.toFixed(2)}</p>
      //   <p><b>Taxe :</b> {resultat.montTaxe.toFixed(2)}</p>
      //   <p><b>Net à percevoir :</b> {resultat.montNet.toFixed(2)}</p>
      // </Box>
    )}

    {/* Tableau des échéances */}
    {echeancier && (
     
      <Box mb={1} fontStyle="inherit" className='border' sx={{p:1}}>
        <Grid item xs={12}>
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table size="small">
          <TableHead>
            <TableRow sx={{  height: 32, minHeight: 32, size:"small",  }}>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}}>Période</TableCell>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}}>Date imputation</TableCell>
           
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}} align="right">Intérêt</TableCell>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}} align="right">Taxe</TableCell>
              <TableCell sx={{ color: '#fff', py: 1,backgroundColor: "#107C41", fontWeight:"bold"}} align="right">Net à payer</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {echeancier.map((row:any,index:number) => (
              <TableRow key={row.periode} sx={{
                                            cursor: 'pointer',
                                            backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
                                             '&:hover': {
                                             // backgroundColor: '#e0f7fa', // Couleur au survol
                                             // background: `linear-gradient(90deg, #1c3adc 0%, #365eff 100%)`,
                                             //color: '#fff', // Texte blanc sur fond sombre
                                             background: 'linear-gradient(90deg, #eaf3ff 0%, #dceeff 100%)',
                                                 },
                                             }}>
                <TableCell>{row.periode}</TableCell>
                <TableCell>{row.dateImput}</TableCell>
                
                <TableCell align="right">{row.interet.toFixed(2)}</TableCell>
                <TableCell align="right">{row.taxe.toFixed(2)}</TableCell>
                <TableCell align="right">{row.netAPayer.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>

          {/* Table Footer pour les totaux */}
    <TableFooter>
      <TableRow sx={{ backgroundColor: "#107C41", color: "#fff", fontWeight: "bold" }}>
        <TableCell colSpan={2} sx={{ color: '#fff', fontWeight: "bold" }}>Total</TableCell>
        <TableCell align="right" sx={{ color: '#fff', fontWeight: "bold" }}>{totalInteret.toFixed(2)}</TableCell>
        <TableCell align="right" sx={{ color: '#fff', fontWeight: "bold" }}>{totalTaxe.toFixed(2)}</TableCell>
        <TableCell align="right" sx={{ color: '#fff', fontWeight: "bold" }}>{totalNet.toFixed(2)}</TableCell>
      </TableRow>
    </TableFooter>
          </Table>
          </TableContainer>
        </Grid>     
      </Box>
    )}

  </DialogContent>
     </Dialog>
    
   
      
    </Box>
  );
};

export default SimulationBDC2List;
